import { makeApolloClient, logError } from '../util';
import { HASHTAGS } from 'queries/hashtag';
import { SET_HASHTAGS, ADD_HASHTAG, REMOVE_HASHTAG, CLEAR_HASHTAGS } from './actionTypes';
import { updateEvent } from './event.action';

export const setHashtags = hashtags => ({ type: SET_HASHTAGS, hashtags });
export const addHashtag = hashtag => ({ type: ADD_HASHTAG, hashtag });
export const removeHashtag = id => ({ type: REMOVE_HASHTAG, id });
export const clearHashtags = () => ({ type: CLEAR_HASHTAGS });

// Mirrors eca-backend's DeleteHashtag.
export const thunkRemoveHashtag = id => (dispatch, getState) => {
	const { hashtags, events } = getState();
	const wasLast = hashtags.hashtags.length === 1 && hashtags.hashtags[0].id === id;
	dispatch(removeHashtag(id));
	if (wasLast && events.currentEvent.hashtag_points_shown) {
		dispatch(updateEvent({ id: events.currentEvent.id, hashtag_points_shown: false }));
	}
};

export const thunkFetchHashtags = eventID => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { hashtags } = await client.request(HASHTAGS, { event_id: eventID });
		dispatch(setHashtags(hashtags));
	} catch (error) {
		logError(error, 'hashtag.actions.thunkFetchHashtags');
	}
};
